import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import SelectionBox from '../SelectionBox/SelectionBox';
import TimePickerHeader from './TimepickerHeader';

const TimepickerContentWrapper = styled.div`
  margin-top: 56px;
  display: ${props => props.isOpen ? 'block' : 'none'};  
  width: 346px;  
  height: auto;
  border-radius: 3px;
  border: solid 1px #e9eff4;
  background-color: #ffffff;
  position: absolute;
  left: -200px;
  padding: 16px 8px;
  padding-right:0;
  padding-bottom: 10px;
  z-index:1;
  @media(min-width: 361px) {
    width: 356px;
    padding: 16px;
    padding-right:0;
  }

  @media(min-width: 800px) {
    width: 490px;
    left: ${props => props.leftPosition};
    margin-bottom: 20px;    
    padding: 16px 14px;
    padding-right:0;
    padding-bottom: 10px;
    &:after{
      left: 8%;
    }
  }
`;

const TimepickerContent = (props) => (
  <TimepickerContentWrapper
    isOpen={props.timePickerOpen}
    ref={props.innerRef}
    leftPosition={props.leftPosition}
  >
    <TimePickerHeader
      handleTimePeriod={props.handleTimePeriod}
      selectedTimePeriod={props.selectedTimePeriod}
    />
    {(props.selectedTimePeriod === "AM") ?
      <SelectionBox
        data={props.AMData}
        handleSelect={props.handleSelect}
        width="82px"
        mobileWidth="64px"
        marginBottom="6px"
        marginRight="10px"
        mobileMarginBottom="14px"
        mobileMarginRight="20px"
        activeElementId={props.selectedTimeId}
      />
      :
      <SelectionBox
        data={props.PMData}
        handleSelect={props.handleSelect}
        width="82px"
        mobileWidth="64px"
        marginBottom="6px"
        marginRight="10px"
        mobileMarginBottom="14px"
        mobileMarginRight="20px"
        activeElementId={props.selectedTime}
      />
    }
  </TimepickerContentWrapper>
);

TimepickerContent.propTypes = {
}

TimepickerContent.defaultProps = {
};

export default TimepickerContent;


// WEBPACK FOOTER //
// ./src/components/UI/TimePicker/TimePickerContent.js